<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <b-card class="p-4 shadow-sm verify-card text-center">

      <!-- LOADING -->
      <div v-if="loading">
        <b-spinner variant="primary" class="mb-3" />
        <p class="text-muted">Memverifikasi akun Anda...</p>
      </div>

      <!-- SUCCESS -->
      <div v-else-if="success">
        <b-icon icon="check-circle-fill" font-scale="4" variant="success" class="mb-3" />
        <h4 class="font-weight-bold">Akun Berhasil Diverifikasi</h4>
        <p class="text-muted mb-4">
          Email Anda telah berhasil diverifikasi.  
          Silakan masuk untuk melanjutkan.
        </p>
        <b-button variant="primary" block @click="goToLogin">
          Masuk Sekarang
        </b-button>
      </div>

      <!-- FAILED -->
      <div v-else>
        <b-icon icon="x-circle-fill" font-scale="4" variant="danger" class="mb-3" />
        <h4 class="font-weight-bold">Verifikasi Gagal</h4>
        <p class="text-muted">
          Link verifikasi tidak valid atau sudah kedaluwarsa.
        </p>
        <b-button variant="outline-primary" block @click="goToLogin">
          Kembali ke Login
        </b-button>
      </div>

    </b-card>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'VerifySuccess',
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      loading: true,
      success: false,
    }
  },
  mounted() {
    const token = this.$route.query.id
    if (!token) {
      this.$router.replace('/login')
    }

    // OPTIONAL: kalau mau verifikasi ke backend
    const decodedId = atob(token)
    console.log('Decoded ID:', decodedId)
    this.verifyToken(decodedId)
  },

  methods: {
    goToLogin() {
      this.$router.push('/login')
    },

    async verifyToken(token) {
      try {
        const response = await axios.post(this.baseapi + 'api/auth/verifyUser', { user_id: token })
        console.log('Verify response:', response)
        this.success = true
      } catch (e) {
        this.success = false
        this.$router.replace('/login')
      }finally {
        this.loading = false
      }
    },
  },
}
</script>
